module.exports = __webpack_public_path__ + "img/phytotherapie.576ae464.svg";